export { StudentRankingPage } from "./StudentRankingPage"
export type { StudentRankingPageProps, UIRankingBoard } from "./StudentRankingPage"
